import staff from "../imgs/staff.png";
import StaffCard from "./StaffCard";

import thao from "../imgs/tas/thao.png";
import stefanie from "../imgs/tas/stefanie.png";
import sameer from "../imgs/tas/sameer.png";
import zachary from "../imgs/tas/zach.png";
import nico from "../imgs/tas/nico.png";
import cat_army from "../imgs/The_Battle_Cats.webp";

import sebastian from "../imgs/tas/sebastian.jpg";
import mohammed from "../imgs/tas/mohammed.png";
import dan from "../imgs/tas/dan.png";
import jason from "../imgs/tas/jason.png";
import yihao from "../imgs/tas/yihao.png";
import tim from "../imgs/tas/tim.png";
import kyle from "../imgs/tas/kyle.png";
import melvin from "../imgs/tas/melvin.png";
import tony from "../imgs/tas/tony.png";
import yuqi from "../imgs/tas/yuqi.png";
import david from "../imgs/tas/david.png";
import sahil from "../imgs/tas/sahil.png";
import lingze from "../imgs/tas/lingze.png";
import omar from "../imgs/tas/omar.png";
import lucas from "../imgs/tas/lucas.png";
import justin from "../imgs/tas/justin.png";
import ethan from "../imgs/tas/ethan.png";
import jiayu from "../imgs/tas/jiayu.jpg";
import sanyu from "../imgs/tas/sanyu.jpg";

function StaffPage() {
  return (
    <div className="staff-page">
      <div className="boat">
        <img className="boat-img" src={cat_army}></img>
      </div>
      <div className="staff">
        <img className="staff-img" src={staff}></img>
      </div>
      <div className="card-wrapper">
        <div className="prof-wrapper sub-wrapper">
          <StaffCard
            img={thao}
            name="Thao Nguyen"
            user="tnguye90"
            pronouns="she/her"
            bio="Hi! I'm a PhD student from Hanoi, Vietnam. My research is on human-robot interaction. I'm very excited to teach this course! In my free time I like to take care of my plants and hang out with my cat Milo :)"
          ></StaffCard>
          <StaffCard
            img={stefanie}
            name="Stefanie Tellex"
            user="stefie10"
            pronouns="she/her"
            bio="Hi!  I'm an Associate Professor of Computer Science at Brown, and I'm interested in robotics, language understanding, and building strong AI!"
          ></StaffCard>
        </div>
        <div className="hta-wrapper sub-wrapper">
          <StaffCard
            img={nico}
            name="Nico Alioto-Pier (HTA)"
            user="naliotop"
            pronouns="he/him"
            bio="Hey, I'm Nico -- a senior from San Francisco. I'm studying AI through Brown's concurrent Sc.M. & Sc.B. program. If you have any questions about the program, the course, or anything else, don't hesitate to shoot me an email or come to my hours!"
          ></StaffCard>
          <StaffCard
            img={sameer}
            name="Sameer Sinha (HTA)"
            user="ssinha"
            pronouns="he/him"
            bio="Hi! My name is Sameer and I'm a senior concentrating in Computer Science. I'm excited to be an HTA for this class, and feel free to reach out with any questions"
          ></StaffCard>
        </div>
        <div className="uta-wrapper sub-wrapper">
          <StaffCard
            img={sebastian}
            name="Sebastian Criado"
            user="scriado"
            pronouns="he/him"
            bio="Hi! I'm a Senior/Concurrent Master's student with both degrees being in Computer Science. In my free time, I love to lift at the Nelson, ski, try different foods, or check out new TV shows."
          ></StaffCard>
          <StaffCard
            img={justin}
            name="Justin Zhu"
            user="jzhu92"
            pronouns="he/him"
            bio="Hi! I'm a senior studying CS and philosophy. I love eating tasty food and playing games with friends!"
          ></StaffCard>
          <StaffCard
            img={mohammed}
            name="Mohammed Khan"
            user="mkhan160"
            pronouns="he/him"
            bio="Hi! I'm a CS master's student from India. In my free time I love reading, walking, and playing chess."
          ></StaffCard>
          <StaffCard
            img={dan}
            name="Daniel Healey"
            user="dhealey5"
            pronouns="he/him"
            bio="Hello, my name is Dan and I am from Fairfax, Virginia. I am a junior concentrating in APMA-CS. In my free time, I enjoy playing board games and hiking."
          ></StaffCard>
          <StaffCard
            img={yihao}
            name="Yi Hao Tan"
            user="ytan30"
            pronouns="he/him"
            bio="Hi! I'm a Junior from Singapore studying CS. In my free time, I enjoy going on walks or watching shows (mostly anime)."
          ></StaffCard>
          <StaffCard
            img={jason}
            name="Jason Silva"
            user="jsilva13"
            pronouns="he/him"
            bio="Hello! I'm a junior from Massachusetts concentrating in CS and APMA. Outside of school I love playing Volleyball and Poker, and am a member of brown's poker club! I'm excited to meet everyone this semester."
          ></StaffCard>
          <StaffCard
            img={lucas}
            name="Lucas Chan"
            user="lchan26"
            pronouns="he/him"
            bio="Hiya! I’m a junior from New Jersey studying APMA - CS and Physics. I love listening to and playing music (always open to recs!), gaming, and drinking way too much boba."
          ></StaffCard>
          <StaffCard
            img={tim}
            name="Tim DeSimone"
            user="tdesimo1"
            pronouns="he/him"
            bio="I'm a junior from Dallas, TX studying computer science. Outside the classroom I enjoy performing in theater, playing and watching sports, and playing 7 wonders with my friends."
          ></StaffCard>
          <StaffCard
            img={kyle}
            name="Kyle Lee"
            user="klee175"
            pronouns="he/him"
            bio="Hi! I'm Kyle, a senior from Santa Clara, CA, concentrating in Applied Math and Computer Science. I enjoy basketball, tennis, skiing, and am highly interested in AI/ML!"
          ></StaffCard>
          <StaffCard
            img={tony}
            name="Tony Zhu"
            user="jzhu57"
            pronouns="he/him"
            bio="Hey yall. My name is Tony and I'm a fifth year masters studying CS. My favorite video game is DoTA 2 so hmu with your profile for extra points (jk)."
          ></StaffCard>
          <StaffCard
            img={yuqi}
            name="Yuqi Lei"
            user="ylei29"
            pronouns="he/him"
            bio="Hi! I'm a master's student interested in computational biology. I love music and play rhythm guitar in the band &quot;10am on Saturday&quot;. Welcome to see our show at Brown's Spring Gala!"
          ></StaffCard>
          <StaffCard
            img={lingze}
            name="Lingze Zhang"
            user="lzhan115"
            pronouns="he/him"
            bio="Hi! I'm Lingze, an ScM student in computer science from China. I like walking around random places in my free time and I'm always happy to meet with old or new friends!"
          ></StaffCard>
          <StaffCard
            img={david}
            name="David Grossman"
            user="dgrossm5"
            pronouns="he/him"
            bio="Hi! I'm a senior from Massachusetts studying APMA-CS. In my free time, I enjoy playing tennis and listening to Tjuvjakt."
          ></StaffCard>
          <StaffCard
            img={zachary}
            name="Zach Sickles"
            user="zsickles"
            pronouns="he/him"
            bio="Hi! I'm a senior from Massachusetts studying Computer Science and Applied Math. I love the outdoors (hiking, camping, skiing), musical theater, binging netflix and coffee!"
          ></StaffCard>
          <StaffCard
            img={omar}
            name="Omar Orozco"
            user="oorozco"
            pronouns="he/him"
            bio="Hi, I am a senior from southern California studying APMA-CS. I enjoy going on walks and traveling to new destinations."
          ></StaffCard>
          <StaffCard
            img={sahil}
            name="Sahil Bansal"
            user="sbansa12"
            pronouns="he/him"
            bio="I am a graduate student getting a Master's in Computer Science. I love reading manga, being with family and friends, and watching cooking shows!"
          ></StaffCard>
          <StaffCard
            img={ethan}
            name="Ethan Asis"
            user="easis"
            pronouns="he/him"
            bio="Hey everyone! My name's Ethan, I'm a rising senior from Minneapolis, MN studying Computer Science and Music. I love movies and nature and I'm looking forward to being your TA!"
          ></StaffCard>
          <StaffCard
            img={jiayu}
            name="Jiayu Zheng"
            user="jzheng70"
            pronouns="he/him"
            bio="I am Jiayu, a second-year master student. One of my favorite pastimes is to look into large models and see what going on behind the scenes with my bare eyes. Nah, I am just kidding. Fruit tarts are my real favorite."
          ></StaffCard>
          <StaffCard
            img={sanyu}
            name="Sanyu Rajakumar"
            user="srajakum"
            pronouns="he/him"
            bio="Hey y'all! I'm Sanyu, and I'm a senior studying Computational Biology. If you ever see me around campus, I'll either be playing volleyball/basketball, doing theatre, or organizing the Brown AI Safety Team (yes I know, how appropriate)."
          ></StaffCard>
          <StaffCard
            img={melvin}
            name="Melvin He (UTA-STA)"
            user="mhe36"
            pronouns="he/him"
            bio="Hi! I'm Melvin, a junior from Massachusetts studying Computer Science. I enjoy biking, cooking, and chilling with family, friends, my 2 pet birds, and cat Munchie!"
          ></StaffCard>
        </div>
      </div>
    </div>
  );
}

export default StaffPage;
